import { Expression } from '../data/text-or-code.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('ClientDataStoreProperty')
export class ClientDataStoreProperty {
	@jsonProperty(String) name!: string
	@jsonProperty(String) type = 'string'
	@jsonProperty(Expression) defaultExpression = new Expression(`''`)

	constructor(init?: Partial<ClientDataStoreProperty>) {
		assignCommonProperties(this, init)
	}
}
